import React, { useState } from "react";

import { supabase } from "../data/projectsStore";

import "./Login.scss";

export const Login = ({ onLoginSuccess }: { onLoginSuccess: () => void }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        throw error;
      }
      onLoginSuccess();
    } catch (err: any) {
      setErrorMsg(err.message || "Erro ao realizar o login. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-ambient-light light-1" />
      <div className="login-ambient-light light-2" />

      <div className="login-card">
        <div className="login-logo">
          <svg
            viewBox="0 0 24 24"
            width="36"
            height="36"
            stroke="currentColor"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="logo-icon"
          >
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
          </svg>
          <h2>Excalidraw Private</h2>
        </div>
        <p className="login-subtitle">
          Acesse seus desenhos em qualquer dispositivo de forma privada.
        </p>

        <form onSubmit={handleLogin} className="login-form">
          {errorMsg && <div className="login-error">{errorMsg}</div>}

          <div className="input-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              required
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              required
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className={`login-submit-btn ${loading ? "loading" : ""}`}
            disabled={loading}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
};
